const callbackMap = new Map();
const cacheMap = new Map();
const SCHEMA = 'snappea://';
const HybridInfo = {
    sdkVersion: '',
    appVersion: 2130001
};
const needJSONReplaceVersion = 2150000;
const __API_TIMEOUT__ = 90000;
const getCallBackName = (() => {
    let reqConter = 0;
    return (api) => {
        return `cb_${api}_${reqConter++}`;
    };
})();
export function jsonReplace(jsonStr) {
    let str = jsonStr;
    // str = str.replace(/\\/g, '\\\\')
    str = str.replace(/\n/g, ' ');
    str = str.replace(/\r/g, ' ');
    str = str.replace(/\t/g, '\\t');
    str = str.replace(/("")+/g, '""');
    str = str.replace(/"\{\\"/g, '"{"');
    str = str.replace(/\\":/g, '":');
    str = str.replace(/":\\"/g, '":"');
    str = str.replace(/,\\"/g, ',"');
    str = str.replace(/\\","/g, '","');
    str = str.replace(/\\"\}"/g, '"}"');
    str = str.replace(/(:"\{")(.*)((\}",)|(\}"\}))/gi, (all, $1, $2, $3) => {
        return `:{"${jsonReplace($2)}${$3.replace('}"', '}')}`;
    });
    return str;
}
export const SnappeaJS = {
    invokeWeb(api, res) {
        try {
            // console.log('HybridInfo:', HybridInfo)
            const result = JSON.parse(HybridInfo.appVersion > needJSONReplaceVersion ? res : jsonReplace(res));
            if (result.res_sn) {
                if (callbackMap.has(result.res_sn)) {
                    callbackMap.get(result.res_sn)?.resolve(result.value);
                    callbackMap.delete(result.res_sn);
                }
                else {
                    console.error(res);
                    throw new Error(`invokeWeb callbackMap undefined, res:${res}`);
                }
            }
            else {
                console.error(res);
                throw new Error(`invokeWeb res_sn undefined, res:${res}`);
            }
        }
        catch (err) {
            console.error(res);
            console.error(err);
            throw new Error(`invokeWeb JSON.parse error`);
        }
    },
    notifyWeb(callbackSn, res) {
        try {
            // console.log('HybridInfo:', HybridInfo)
            const result = JSON.parse(HybridInfo.appVersion > needJSONReplaceVersion ? res : jsonReplace(res));
            if (callbackMap.has(callbackSn)) {
                callbackMap.get(callbackSn)?.resolve(result);
            }
            else {
                throw new Error(`notifyWeb callbackMap undefined, res:${res}`);
            }
        }
        catch (err) {
            console.error(res);
            console.error(err);
            throw new Error(`notifyWeb JSON.parse error`);
        }
    }
};
export function invokeApi({ api, params = {}, timeout = 0, callback }) {
    const schemaUrl = `${SCHEMA}${api}?value=${encodeURIComponent(JSON.stringify(params))}`;
    const callbackName = getCallBackName(api);
    const iframe = document.createElement('iframe');
    let fullUrl = schemaUrl;
    iframe.id = callbackName;
    iframe.style.display = 'none';
    if (callback) {
        fullUrl += `&req_sn=${callbackName}`;
        // console.log(`callbackMap set ${callbackName}`)
        callbackMap.set(callbackName, callback);
        // 调用超时
        if (timeout > 0) {
            setTimeout(() => {
                // 回调成功会移除 callbackMap
                if (callbackMap.has(callbackName)) {
                    const err = new Error(`${api} timeout ${timeout}`);
                    callback?.reject(err);
                }
            }, timeout);
        }
    }
    iframe.setAttribute('src', fullUrl);
    document.body.appendChild(iframe);
    setTimeout(function () {
        iframe.parentNode && iframe.parentNode.removeChild(iframe);
    }, __API_TIMEOUT__);
}
function isHigherVersion(thisVersionName, comparedVersionName) {
    const thisVersionArray = thisVersionName.split('.');
    const comparedVersionArray = comparedVersionName.split('.');
    if (thisVersionArray.length < 3 || comparedVersionArray.length < 3) {
        throw new TypeError('Your provide version string can not be compared.');
    }
    for (let i = 0; i < 3; i++) {
        const thisVersionItem = +thisVersionArray[i];
        const comparedVersionItem = +comparedVersionArray[i];
        if (thisVersionItem < comparedVersionItem) {
            return false;
        }
        if (thisVersionItem === comparedVersionItem) {
            continue;
        }
        if (thisVersionItem > comparedVersionItem) {
            return true;
        }
    }
    return true;
}
function invokeCoreApi(api) {
    return new Promise((resolve, reject) => {
        if (cacheMap.has(api)) {
            return resolve(cacheMap.get(api));
        }
        else {
            invokeApi({
                api,
                params: {},
                timeout: __API_TIMEOUT__,
                callback: {
                    resolve: (result) => {
                        cacheMap.set(api, result);
                        resolve(result);
                    },
                    reject
                }
            });
        }
    });
}
/**
 * 判断 hybrid SDK 版本号
 * 所有 api 的前置条件
 */
export const getThisSDKVersionName = () => {
    return invokeCoreApi('com.dywx.hybrid.handler.AppInfoHandler/getVersionCode')
        .then(appVersion => {
        HybridInfo.appVersion = appVersion;
        return appVersion;
    })
        .then(() => invokeCoreApi('com.dywx.hybrid.handler.SdkInfoHandler/getSdkVersionName'))
        .then(sdkVersion => {
        HybridInfo.sdkVersion = sdkVersion;
        return sdkVersion;
    });
};
export function requestAPI({ api, params = {}, useCache = false, versionLimit = '', timeout = __API_TIMEOUT__, needResp = true }) {
    // 先判断是否支持
    return getThisSDKVersionName().then(version => {
        return new Promise((resolve, reject) => {
            if (versionLimit && !isHigherVersion(version, versionLimit)) {
                console.error(`当前SDK版本名: ${version}`);
                reject(new Error(`API请求失败，${api} 需 ${versionLimit} 版本SDK`));
            }
            if (useCache && cacheMap.has(api)) {
                resolve(cacheMap.get(api));
            }
            else {
                invokeApi({
                    api,
                    params,
                    timeout,
                    callback: needResp
                        ? {
                            resolve: (result) => {
                                if (useCache) {
                                    cacheMap.set(api, result);
                                }
                                resolve(result);
                            },
                            reject
                        }
                        : undefined
                });
                // setTimeout(() => {
                //   console.log(`${api} 超时`)
                //   resolve('{}' as any)
                // }, __API_TIMEOUT__)
            }
        });
    });
}
